// frontend/src/pages/PayrollItems/data.ts
// Typed re-export of ../../data/payrollItemsData (which is still JS).
// This file is the one place where the untyped boundary is bridged; the
// underlying data file can be converted to .ts in a future small PR without
// touching any consumer of this re-export.

import {
  PAY_TYPES as PAY_TYPES_RAW,
  SCHEDULES as SCHEDULES_RAW,
  LOCATIONS as LOCATIONS_RAW,
  DEDUCTIONS as DEDUCTIONS_RAW,
} from "../../data/payrollItemsData";
import type { PayType, Schedule, Location, Deduction } from "./types";

export const PAY_TYPES = PAY_TYPES_RAW as readonly PayType[];
export const SCHEDULES = SCHEDULES_RAW as readonly Schedule[];
export const LOCATIONS = LOCATIONS_RAW as readonly Location[];
export const DEDUCTIONS = DEDUCTIONS_RAW as readonly Deduction[];